import apiClient from "../../axios/apiClient";

export const getDashboardData = (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_DASHBOARD_DATA_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Dashboard-Status-Count`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_DASHBOARD_DATA_FULFILLED",
        payload: response.data,
      });
    }
    catch (error) {
      dispatch({
        type: "GET_DASHBOARD_DATA_REJECTED",
        payload: error.response,
      });
    }
  };

/**
 * Single action for Dashboard-Search API.
 * @param {string} token - Auth token
 * @param {string} type - One of: monthly_report | claim_type_split | fo_wise | city_wise | hospital_wise | insurance_wise
 * @param {string|number} value - Active | Complete | or respective id (claim_type_id, user_id, city_id, hospital_id, insurance_id)
 * @param {string|number} [claimTypeId] - For insurance_wise: claim_type_id (required along with value = insurance_id)
 */
export const getDashboardSearchCases = (token, type, value, claimTypeId) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MONTHLY_REPORT_PENDING" });
      const params = { type, value };
      if (type === "insurance_wise" && claimTypeId != null && claimTypeId !== "") {
        params.claim_type_id = claimTypeId;
      }
      const response = await apiClient.get(
        `/api/admin/V1/Case/Dashboard-Search`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MONTHLY_REPORT_FULFILLED",
        payload: response.data?.data ?? response.data ?? [],
      });
    } catch (error) {
      dispatch({
        type: "GET_MONTHLY_REPORT_REJECTED",
        payload: error.response,
      });
    }
  };


